module.exports = __webpack_public_path__ + "img/wechat.343cc2ce.png";